<!-- =========================================================================================
  File Name: CrewAssignmentManagement.vue
  Description: Crew Assignment Management Top Page
  Component Name: CrewAssignmentManagement
========================================================================================== -->

<template>
  <div>
    <assigned-vessel-list
      :vessels="getManningVessels"
      :onboarding-crews="getOnboardingCrews"
      :ashore-crews="getAshoreCrews"
      :crews-roles="getCrewsRoles"
      :vessel-alerts="getManningVesselsAlerts"
      :crew-alerts="getCrewAlerts"
      :crew-alert-settings="getCrewAlertSettings"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import AssignedVesselList from "./components/AssignedVesselList.vue";
import { HandleHttpErrorService } from "./utils/errors";

const { mapActions, mapGetters } = createNamespacedHelpers(
  "crewAssignmentManagement"
);

export default {
  components: { AssignedVesselList },
  methods: {
    ...mapActions([
      "fetchEnterpriseManningVessels",
      "fetchEnterpriseOnboardingCrews",
      "fetchEnterpriseAshoreCrews",
      "fetchEnterpriseCrewsRoles",
      "fetchEnterpriseManningVesselAlerts",
      "fetchEnterpriseCrewsAlerts",
      "fetchEnterpriseCrewAlertSettings",
    ]),
    async fetchData() {
      const fetchEnterpriseManningVesselsParams = {
        details: ["MANNING_VESSEL_ROLE", "MANNING_VESSEL_ROLE_POSITION"],
      };
      const fetchEnterpriseOnboardingCrewsParams = {
        manning_vessel_details: ["MANNING_VESSEL_CREW_ROLE"],
      };
      const fetchEnterpriseAshoreCrewsParams = {
        details: ["CREW_AVAILABLE_ROLE"],
      };
      const fetchEnterpriseManningVesselAlertsParams = {
        kinds: ["REPLACEMENT_CREW_NOT_ASSIGNED"],
      };

      const fetchEnterpriseCrewsAlertsParams = {
        kinds: [
          "EMBARKATION_STANDBY",
          "DISEMBARKATION_STANDBY",
          "DAY_OFF_REQUEST_DUPLICATED",
        ],
      };

      try {
        await Promise.all([
          this.fetchEnterpriseManningVessels(
            fetchEnterpriseManningVesselsParams
          ),
          this.fetchEnterpriseOnboardingCrews(
            fetchEnterpriseOnboardingCrewsParams
          ),
          this.fetchEnterpriseAshoreCrews(fetchEnterpriseAshoreCrewsParams),
          this.fetchEnterpriseCrewsRoles(),
          this.fetchEnterpriseManningVesselAlerts(
            fetchEnterpriseManningVesselAlertsParams
          ),
          this.fetchEnterpriseCrewsAlerts(fetchEnterpriseCrewsAlertsParams),
          this.fetchEnterpriseCrewAlertSettings(),
        ]);
      } catch (error) {
        const message = HandleHttpErrorService.handleErrorNotificationMessage(
          error
        );
        this.$vs.notify({
          title: "通信に失敗しました",
          text: message,
          color: "danger",
        });
        return;
      }
    },
  },
  computed: {
    ...mapGetters([
      "getManningVessels",
      "getOnboardingCrews",
      "getAshoreCrews",
      "getCrewsRoles",
      "getManningVesselsAlerts",
      "getCrewAlerts",
      "getCrewAlertSettings",
    ]),
  },
  created() {
    this.fetchData();
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
  },
};
</script>

<style lang="scss" scoped></style>
